/**
 * O botão da página. Sai como `<a>` quando tem `href` e como `<button>` quando
 * não tem — e não o contrário disfarçado: as chamadas daqui levam para o
 * WhatsApp ou para uma âncora, e um `<button>` com `onClick={navigate}` tira de
 * quem usa o "abrir em nova aba", o arrastar para os favoritos e o endereço na
 * barra de status.
 *
 * Link externo leva `rel="noopener noreferrer"` por padrão: sem `noopener` a
 * página aberta ganha uma referência à nossa pela `window.opener`.
 */
function AppButton({
  variant = 'primary',
  size,
  href,
  external,
  className = '',
  children,
  ...props
}) {
  const classes = [
    'btn-lp',
    `btn-lp--${variant}`,
    size ? `btn-lp--${size}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (href) {
    // Âncora interna (#planos) nunca abre em outra aba: o destino está na mesma
    // página, e uma segunda aba idêntica só confunde.
    const abreFora = external ?? !href.startsWith('#');
    return (
      <a
        href={href}
        className={classes}
        {...(abreFora ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...props}>
      {children}
    </button>
  );
}

export default AppButton;
